import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import styles from "./RichText.module.scss";

const { sanitize } = dompurify;

export interface RichTextProps {
  content: string;
  className?: string;
  additionalClassName?: string;
  isDarkMode?: boolean;
  dataTestId?: string;
}

export type RichTextPropsContent = Pick<RichTextProps, "content" | "isDarkMode">;

export const RichText = ({ content, className, isDarkMode = false, dataTestId }: RichTextProps) => (
  <div
    className={classNames(className, {
      [styles.darkMode]: isDarkMode,
    })}
    data-testid={dataTestId}
    dangerouslySetInnerHTML={{ __html: sanitize(content) }}
  ></div>
);
